// extracted by mini-css-extract-plugin
var _1 = "ActivityStats__image--pbl14";
var _2 = "ActivityStats__main--kvxXn";
var _3 = "ActivityStats__number--czDKe";
var _4 = "ActivityStats__officeMain--MMW8c ActivityStats__main--kvxXn";
var _5 = "ActivityStats__row--McYoR ActivityStats__rowBase--xnllA";
var _6 = "ActivityStats__rowBase--xnllA";
var _7 = "ActivityStats__rowGray--IFpl5 ActivityStats__row--McYoR ActivityStats__rowBase--xnllA";
var _8 = "ActivityStats__statPC--ucweD";
var _9 = "ActivityStats__statPlaceholder--umE4d ActivityStats__image--pbl14";
var _a = "ActivityStats__statStarsInner--r3Q8T";
var _b = "ActivityStats__statTime--BBqLs";
var _c = "ActivityStats__subrow--tI718 ActivityStats__rowBase--xnllA fontSize__profileSmallPlus--_oZpO";
var _d = "ActivityStats__textOnly--us57F";
var _e = "ActivityStats__type--GBmQO";
var _f = "ActivityStats__verb--_b8ET";
export { _1 as "image", _2 as "main", _3 as "number", _4 as "officeMain", _5 as "row", _6 as "rowBase", _7 as "rowGray", _8 as "statPC", _9 as "statPlaceholder", _a as "statStarsInner", _b as "statTime", _c as "subrow", _d as "textOnly", _e as "type", _f as "verb" }
